import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import { dataSourceList, dataSourceSync } from '@/api/form/formManageApi.js';
import setList from './components/setList.vue';
export default {
  data: function data() {
    return {
      loading: false,
      setId: '',
      form: {
        name: undefined,
        status: undefined,
        typeId: undefined
      },
      sourceObj: {
        params: ''
      },
      sourceList: []
    };
  },
  methods: {
    sourceFetch: function sourceFetch() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var $nextTick, $refs, res, sjybm;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              $nextTick = _this.$nextTick, $refs = _this.$refs;
              _context.p = 1;
              _this.loading = true;
              _context.n = 2;
              return dataSourceList(_this.sourceObj);
            case 2:
              res = _context.v;
              _this.sourceList = res.data.data;
              if (!_.isEmpty(_this.sourceList)) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              sjybm = _.head(_this.sourceList).sjybm;
              _this.setId = sjybm;
              $nextTick(function () {
                $refs.setList.loadData(sjybm);
              });
            case 4:
              _context.p = 4;
              _this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 4, 5]]);
      }))();
    },
    // 数据源切换查询数据集
    onSourceClick: function onSourceClick(row) {
      var $nextTick = this.$nextTick,
        $refs = this.$refs;
      this.setId = row.sjybm;
      $nextTick(function () {
        $refs.setList.loadData(row.sjybm);
      });
    },
    // 刷新
    onSourceRefresh: function onSourceRefresh() {
      var $message = this.$message,
        sourceFetch = this.sourceFetch;
      $message.success('刷新成功');
      sourceFetch();
    },
    // 数据源同步
    onSourceSync: function onSourceSync(row) {
      var _this2 = this;
      var $confirm = this.$confirm,
        $message = this.$message,
        sourceFetch = this.sourceFetch;
      $confirm("确认进行同步吗？", "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        _this2.loading = true;
        dataSourceSync({
          sjybm: row.sjybm
        }).then(function (res) {
          if (200 === res.data.code) {
            $message.success('同步成功！');
            sourceFetch();
          }
        }).finally(function () {
          _this2.loading = false;
        });
      }).catch(function () {});
    }
  },
  mounted: function mounted() {
    this.sourceFetch();
  },
  components: {
    setList: setList
  }
};